<script>
    import Slider from '../Slider/VSlider.svelte';
    import { hsl2rgb, rgb2hsl } from '@scanex/color';    
    import './AlphaSlider.css';
    
    export let alpha = 100;    
    export let hue = 0;
    export let saturation = 1.0;
    export let lightness = 0.5;
    
    let canvas;

    $: {
        if (canvas) {
            const {r, g, b} = hsl2rgb(hue, saturation, lightness);
            let ctx = canvas.getContext('2d');
            let imgData = ctx.getImageData (0, 0, canvas.width, canvas.height);
            let {data, width, height} = imgData;
            for (let i = 0; i < data.length; i += 4){
                data[i + 0] = r;
                data[i + 1] = g;
                data[i + 2] = b;
                data[i + 3] = Math.round (255 * alpha / 100);
            }
            ctx.putImageData (imgData, 0, 0);
        }
    }

</script>

<div class="alpha-slider">
    <Slider tooltip="true" min="0" max="100" high="0" step="0" bind:value="{alpha}">
        <canvas bind:this="{canvas}"></canvas>
    </Slider>
</div>